import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import type { ClassValue } from 'clsx';

const FONT_SIZES = [
  'page-title', 'title-funnel', 'title-card',
  'body', 'body-semibold', 'body-regular',
  'control', 'control-semibold', 'control-button',
  'caption', 'caption-semibold', 'caption-body', 'caption-sm', 'caption-sm-semibold',
  'eyebrow',
  'mono-page-title', 'mono-body', 'mono-caption', 'mono-sm', 'mono-micro',
];

const RADII = ['sm', 'input', 'md', 'lg', 'modal', 'pill'];

const SHADOWS = ['sm', 'modal', 'focus'];

const SPACINGS = [
  'sidebar', 'sidebar-collapsed', 'nav-item', 'table-header', 'table-row',
  'button', 'input', 'drawer', 'deck-rail', 'modal', 'content-min',
];

const SPACING_PREFIXES = [
  'p', 'px', 'py', 'pt', 'pr', 'pb', 'pl',
  'm', 'mx', 'my', 'mt', 'mr', 'mb', 'ml',
  'gap', 'w', 'h', 'min-w', 'min-h', 'max-w', 'max-h', 'basis', 'size',
];

const spacingGroups = Object.fromEntries(
  SPACING_PREFIXES.map(prefix => [prefix, [{ [prefix]: SPACINGS }]]),
);

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZES }],
      'rounded': [{ rounded: RADII }],
      'shadow': [{ shadow: SHADOWS }],
      ...spacingGroups,
    },
  },
});

const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export {
  cn,
};
